(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/admin/dialog-adapter/assets/javascripts/alert-popup.js') >= 0) return;  svs.modules.push('/components/admin/dialog-adapter/assets/javascripts/alert-popup.js');
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var dialog = svs.ui.dialog;
var _svs$components$dialo = svs.components.dialogWrapper.helper,
  button = _svs$components$dialo.button,
  cmsType = _svs$components$dialo.cmsType,
  icon = _svs$components$dialo.icon,
  newDialog = _svs$components$dialo.newDialog,
  text = _svs$components$dialo.text;
var Type = svs.components.dialogAdapter.helper.Type;

var convertTypeToCmsType = function convertTypeToCmsType(type) {
  switch (type) {
    case Type.ERROR:
      return cmsType.ERROR;
    default:
      return cmsType.CONFIRM;
  }
};

var AlertPopup = function () {
  function AlertPopup() {
    var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, AlertPopup);
    this.title = title;
    this.message = options.message;
    this.type = convertTypeToCmsType(options.type || Type.DEFAULT);
    this.icon = icon[this.type];
  }
  return _createClass(AlertPopup, [{
    key: "show",
    value:
    function show() {
      newDialog({
        area: dialog.area.POPUP,
        buttons: [button({
          title: 'Ok'
        })],
        message: [text({
          text: this.message || ''
        })],
        icon: this.icon,
        title: this.title,
        type: "".concat(this.type, " message-box-message}")
      });
    }
  }]);
}();
_defineProperty(AlertPopup, "Type", Type);
svs.components.AlertPopup = AlertPopup;

 })(window);